import React, { useCallback, useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Moment from "moment";
import { extendMoment } from "moment-range";
import classNames from "classname";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import HelpIcon from "@material-ui/icons/Help";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  getSchedulesJSON,
  hasEmptyDays,
  getSanitizedSchedule,
} from "../../services/scheduler/utils";
import {
  getSchedule,
  getAttendeeDataFlag,
} from "../../services/create_schedule/actions";

import { InfoMessage } from "./../Messages/index";
import ViewAttendeeModal from "./../../components/ViewAttendeeModal/index";
import RescheduleModal from "./../../components/RescheduleModal/index";
import Setting from "./../../components/Setting/index";
const moment = extendMoment(Moment);
const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const HourSlots = ({
  step,
  dateRange,
  activeDay,
  onChange,
  selectedSlots = [],
  multiselect = true,
  customTimeSlots = null,
  readOnly,
  attendeeSchedulesList,
  eventName,
  specialInstructions,
  CheckSlotDetailsFill = (e) => null,
  attendeeId,
  eventId,
  CheckWaitingList,
  setActiveDate,
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [seats, setAvailableSeats] = React.useState(null);

  const [waitingseats, setWaitingSeats] = React.useState(0);
  const [duration, setDuration] = React.useState("60");
  const [durationunit, setDurationUnit] = React.useState("minute");
  const [reminder, setReminder] = React.useState("yes");
  const [reminderhour, setReminderHour] = React.useState("24");
  const [selectedSlot, setSelectedSlot] = React.useState(null);
  const noofseets = useRef("1");
  const [isAvailableSeatError, setIsAvailableSeatError] = React.useState(false);
  const [isWaitingSeatError, setIsWaitingSeatError] = React.useState(false);
  const [isDurationSeatError, setIsDurationSeatError] = React.useState(false);

  const [
    isAvailableSeatErrorMessage,
    setIsAvailableSeatErrorMessage,
  ] = React.useState("");
  const [
    isDurationSeatErrorMessage,
    setIsDurationSeatErrorMessage,
  ] = React.useState("");
  const [
    isWaitingSeatErrorMessage,
    setIsWaitingSeatErrorMessage,
  ] = React.useState("");
  const [expanded, setExpanded] = React.useState(0);
  const [isOpenAtendeeViewModal, setIsOpenAtendeeViewModal] = React.useState(
    false
  );
  const [selectedDateTime, setSelectedDateTime] = React.useState("");
  const schedule = useSelector((state) => state.scheduler.schedule);
  const [attendeeData, setAttendeeData] = React.useState("");
  const [isSettingViewModal, setIsSettingViewModal] = React.useState(false);
  const [isRescheduleModal, setIsRescheduleModal] = React.useState(false);
  const [rescheduledata, setRescheduledata] = React.useState(null);
  const isAttendeeData = useSelector(
    (state) => state.scheduleCreationData.isAttendeeData
  );
  const selectedViewAttendeeData = useSelector(
    (state) => state.scheduleCreationData.selectedViewAttendeeData
  );
  const eventLocation = useSelector(
    (state) => state.slotPickupData.eventLocation
  );
  //let AttendeeData = "";
  //const useStyles = makeStyles(theme => ({
  //    formControl: {
  //        margin: theme.spacing(1),
  //        minWidth: 120,
  //    },
  //    selectEmpty: {
  //        marginTop: theme.spacing(2),
  //    },
  //}));

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }));

  const classes = useStyles();

  const handleExpandChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handlePopoverClick = (event, selectedSlotObj) => {
    if (customTimeSlots) {
      event.preventDefault();
      return false;
    }
    setAnchorEl(event.currentTarget);
    if (selectedSlotObj) {
      selectedSlots.map((item) => {
        item.isAvailableSeatsPopOverOpened = false;
      });
      if (selectedSlots.length > 0) {
        const index = selectedSlots.findIndex(
          (x) => x.slotTime === selectedSlotObj.slotTime
        );
        if (index !== -1) {
          selectedSlots[index].isAvailableSeatsPopOverOpened = true;
          //selectedSlots[index].seats = 1;
          if (selectedSlots[index].seats === 0) {
            setTimeout(
              function (noofseets) {
                noofseets.current.focus();
                noofseets.current.value = 1;
              },
              200,
              noofseets
            );
          }
        }
      }
    }
    clearAllControls();
  };

  const OnAvailableSeatsInputChange = (event, selectedSlotObj) => {
    setAvailableSeats(event.target.value);
    //if (selectedSlots.length > 0) {
    //    const index = selectedSlots.findIndex(x => x.slotTime === selectedSlotObj.slotTime);
    //    if (index !== -1) {
    //        selectedSlots[index].seats = event.target.value;
    //    }

    //}
  };

  const OnAvailableWaitingSlotInputChange = (event, selectedSlotObj) => {
    setWaitingSeats(event.target.value);
    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].waitingseats = waitingseats;
      }
    }
  };

  const OnDurationInputChange = (event, selectedSlotObj) => {
    setDuration(event.target.value);
    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].duration = duration;
      }
    }
  };

  const OnDurationUnitInputChange = (event, selectedSlotObj) => {
    setDurationUnit(event.target.value);
    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].durationunit = event.target.value;
      }
    }
  };

  const OnReminderInputChange = (event, selectedSlotObj) => {
    setReminder(event.target.value);
    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].reminder = event.target.value;
      }
    }
  };

  const OnReminderHourInputChange = (event, selectedSlotObj) => {
    setReminderHour(event.target.value);
    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].reminderhour = event.target.value;
      }
    }
  };

  const clearAllControls = () => {
    setIsAvailableSeatError(false);
    setIsAvailableSeatErrorMessage("");
    setIsWaitingSeatError(false);
    setIsWaitingSeatErrorMessage("");
    setIsDurationSeatError(false);
    setIsDurationSeatErrorMessage("");
  };

  const validateControlls = () => {
    var isValid = true;
    if (
      noofseets.current.value === "" ||
      noofseets.current.value === null ||
      noofseets.current.value <= 0 ||
      noofseets.current.value.indexOf(".") > -1
    ) {
      if (noofseets.current.value === "" || noofseets.current.value === null) {
        setIsAvailableSeatErrorMessage("This filed is required.");
      } else if (noofseets.current.value.indexOf(".") > -1) {
        setIsAvailableSeatErrorMessage("Invalid Input");
      } else {
        setIsAvailableSeatErrorMessage("Value must be greater than 0.");
      }

      setIsAvailableSeatError(true);
      isValid = false;
    } else {
      setIsAvailableSeatError(false);
      setIsAvailableSeatErrorMessage("");
    }

    if (
      waitingseats === "" ||
      waitingseats === null ||
      waitingseats < 0 ||
      waitingseats.toString().indexOf(".") > -1 ||
      waitingseats.toString().indexOf("-") > -1
    ) {
      if (waitingseats === "") {
        setIsWaitingSeatErrorMessage("This filed is required.");
      } else if (
        waitingseats.toString().indexOf(".") > -1 ||
        waitingseats.toString().indexOf("-") > -1
      ) {
        setIsWaitingSeatErrorMessage("Invalid Input");
      } else {
        setIsWaitingSeatErrorMessage("Value must be greater than 0.");
      }
      setIsWaitingSeatError(true);
      isValid = false;
    } else {
      setIsWaitingSeatError(false);
      setIsWaitingSeatErrorMessage("");
    }
    if (
      duration === null ||
      duration === "" ||
      duration === "0" ||
      duration.indexOf(".") > -1 ||
      duration.indexOf("-") > -1
    ) {
      if (duration === "" || duration === null) {
        setIsDurationSeatErrorMessage("This filed is required.");
      } else if (duration.indexOf(".") > -1 || duration.indexOf("-") > -1) {
        setIsDurationSeatErrorMessage("Invalid Input");
      } else {
        setIsDurationSeatErrorMessage("Value must be greater than 0.");
      }
      setIsDurationSeatError(true);
      isValid = false;
    } else {
      setIsDurationSeatError(false);
      setIsDurationSeatErrorMessage("");
    }
    return isValid;
  };

  const handlePopoverClose = (event, selectedSlotObj, isButtonClick) => {
    if (isButtonClick) {
      if (validateControlls()) {
        if (selectedSlots.length > 0) {
          const index = selectedSlots.findIndex(
            (x) => x.slotTime === selectedSlotObj.slotTime
          );
          if (index !== -1) {
            selectedSlots[index].seats = noofseets.current.value;
            selectedSlots[index].waitingseats = waitingseats;
            selectedSlots[index].duration = duration;
            selectedSlots[index].durationunit = durationunit;
          }
        }

        //setAvailableSeats(0);
        //setWaitingSeats(0);
        //setDuration(null);
        //setDurationUnit('hour');
        setAnchorEl(null);
        selectedSlots.map((item) => {
          item.isAvailableSeatsPopOverOpened = false;
        });
        CheckSlotDetailsFill(true);
      }
    }

    if (isButtonClick !== true) {
      setAnchorEl(null);
      selectedSlots.map((item) => {
        item.isAvailableSeatsPopOverOpened = false;
      });
    }
  };

  const closeDialog = (event, selectedSlotObj) => {
    setAnchorEl(null);

    if (selectedSlots.length > 0) {
      const index = selectedSlots.findIndex(
        (x) => x.slotTime === selectedSlotObj.slotTime
      );
      if (index !== -1) {
        selectedSlots[index].seats = 0;
        selectedSlots[index].waitingseats = 0;
        selectedSlots[index].duration = "60";
        selectedSlots[index].durationunit = "minute";
        CheckSlotDetailsFill(false);
      }
    }

    selectedSlots.map((item) => {
      item.isAvailableSeatsPopOverOpened = false;
    });
  };

  const getCurrentAttendee = (aid) => {
    var attendee = undefined;
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.attendeeId === aid) {
          attendee = item;
          return attendee;
        }
      });
    }

    return attendee;
  };

  const getDuration = () => {
    var duration = "";
    var selectedTime = "";
    var currentAttendee = getCurrentAttendee(attendeeId);
    if (currentAttendee !== undefined) {
      var currentAttendeeSchedule = JSON.parse(currentAttendee.schedules);
      if (currentAttendeeSchedule !== undefined) {
        selectedTime = currentAttendeeSchedule[0].time[0].slotTime;
      }
    }
    if (Array.isArray(customTimeSlots)) {
      customTimeSlots.map((el, index) => {
        if (el.slotTime === selectedTime) {
          duration = el.duration + " " + el.durationunit;
        }
        return;
      });
    }

    return duration;
  };

  const getTimeSlot = () => {
    var selectedTime = "";
    var selectedAttendeeTimeSlot = undefined;
    var currentAttendee = getCurrentAttendee(attendeeId);
    if (currentAttendee !== undefined) {
      var currentAttendeeSchedule = JSON.parse(currentAttendee.schedules);
      if (currentAttendeeSchedule !== undefined) {
        selectedTime = currentAttendeeSchedule[0].time[0].slotTime;
      }
    }
    if (Array.isArray(customTimeSlots)) {
      customTimeSlots.map((el, index) => {
        if (el.slotTime === selectedTime) {
          selectedAttendeeTimeSlot = el;
        }
        return;
      });
    }

    return selectedAttendeeTimeSlot;
  };

  const getRemainingSlots = (dateSlot, timeSlot, totalSlots, waitingseats) => {
    let numberOfAttendeesFound = 0;
    let numberOfConfrimAttendees = 0;
    let numberOfWatingAttendees = 0;
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        //if (item.isConfirm === true) {
        //    numberOfAttendeesFound++;
        //}

        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isConfirm === true || item.isWaiting === true) {
                        numberOfConfrimAttendees =
                          item.isConfirm == true
                            ? numberOfConfrimAttendees + 1
                            : numberOfConfrimAttendees;
                        numberOfWatingAttendees =
                          item.isWaiting == true
                            ? numberOfWatingAttendees + 1
                            : numberOfWatingAttendees;
                        numberOfAttendeesFound++;
                      }

                      //numberOfAttendeesFound++;
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
    let numberOfAttendeeInfo = "";
    if (parseInt(totalSlots) > numberOfConfrimAttendees) {
      numberOfAttendeeInfo = (
        <div>
          {parseInt(totalSlots) - numberOfConfrimAttendees} of{" "}
          {parseInt(totalSlots)} slots remaining.
        </div>
      );
    } else if (
      numberOfAttendeesFound >= parseInt(totalSlots) &&
      numberOfAttendeesFound < parseInt(totalSlots) + parseInt(waitingseats)
    ) {
      if (customTimeSlots) {
        numberOfAttendeeInfo = (
          <div style={{ color: "red" }}>
            All slots filled, to be added to the waitlist please fill out your
            details.
          </div>
        );
      } else {
        numberOfAttendeeInfo = (
          <div style={{ color: "red" }}>All slots filled.</div>
        );
      }
    } else if (
      parseInt(totalSlots) + parseInt(waitingseats) ===
      numberOfAttendeesFound
    ) {
      numberOfAttendeeInfo = (
        <div style={{ color: "red" }}>No availability, all slots filled.</div>
      );
    }
    //let numberOfAttendeeInfo = (<div>{(parseInt(totalSlots) - numberOfAttendeesFound)} of {totalSlots} slots remaining.</div>);
    return <InfoMessage title={numberOfAttendeeInfo} />;

    //"Total slots " + totalSlots + ";" + (parseInt(totalSlots) - numberOfAttendeesFound) + " slots remaining"
    //let numberOfAttendeeInfo = (<div>{(parseInt(totalSlots) - numberOfAttendeesFound)} of {totalSlots} slots remaining.</div>);
    //return (<InfoMessage title={numberOfAttendeeInfo} />);
  };

  const getConfirmRemainingSlots = (dateSlot, timeSlot, totalSlots) => {
    let numberOfAttendeesFound = 0;
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.isConfirm === true) {
          numberOfAttendeesFound++;
        }
      });
    }
    let numberOfAttendeeInfo = "";
    if (parseInt(totalSlots) - numberOfAttendeesFound === 0) {
      numberOfAttendeeInfo = (
        <div style={{ color: "red" }}>All slots filled.</div>
      );
    } else {
      numberOfAttendeeInfo = (
        <div>
          {parseInt(totalSlots) - numberOfAttendeesFound} of {totalSlots} slots
          remaining.
        </div>
      );
    }

    return <InfoMessage title={numberOfAttendeeInfo} />;
  };

  const getWaitingRemainingSlots = (dateSlot, timeSlot, totalSlots) => {
    let numberOfAttendeesFound = 0;
    if (totalSlots === undefined || totalSlots === null || totalSlots === "") {
      totalSlots = "0";
    }
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.isWaiting === true) {
          numberOfAttendeesFound++;
        }

        //if (item.schedules) {
        //    let parsedSchedules = JSON.parse(item.schedules);
        //    if (parsedSchedules) {
        //        for (let p = 0; p < parsedSchedules.length; p++) {
        //            if (parsedSchedules[p].date === dateSlot) {
        //                if (parsedSchedules[p].time) {
        //                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
        //                        if (parsedSchedules[p].time[i].slotTime === timeSlot) {
        //                            numberOfAttendeesFound++;
        //                        }
        //                    }
        //                }
        //            }
        //        }
        //    }
        //}
      });
    }
    //"Total slots " + totalSlots + ";" + (parseInt(totalSlots) - numberOfAttendeesFound) + " slots remaining"
    let numberOfAttendeeInfo = (
      <div>
        {parseInt(totalSlots) - numberOfAttendeesFound} of {totalSlots} slots
        remaining.
      </div>
    );
    return <InfoMessage title={numberOfAttendeeInfo} />;
  };

  const getRemainingSlotsCount = (
    dateSlot,
    timeSlot,
    totalSlots,
    waitingseats
  ) => {
    let numberOfAttendeesFound = 0;
    let numberOfConfrimAttendees = 0;
    let numberOfWatingAttendees = 0;
    let IsDisable = false;

    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        //if (item.isConfirm === true || item.isWaiting === true) {
        //    numberOfAttendeesFound++;
        //}
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isConfirm === true || item.isWaiting === true) {
                        numberOfConfrimAttendees =
                          item.isConfirm == true
                            ? numberOfConfrimAttendees + 1
                            : numberOfConfrimAttendees;
                        numberOfWatingAttendees =
                          item.isWaiting == true
                            ? numberOfWatingAttendees + 1
                            : numberOfWatingAttendees;
                        numberOfAttendeesFound++;
                      }

                      //numberOfAttendeesFound++;
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
    if (
      parseInt(totalSlots) + parseInt(waitingseats) ===
      numberOfAttendeesFound
    ) {
      IsDisable = true;
    }

    return IsDisable;
  };

  const getRemainingAndWaitingSlotsCount = () => {
    var currentAttendee = getCurrentAttendee(attendeeId);
    var currentAttendeeTimeSlot = getTimeSlot();

    if (
      currentAttendee !== undefined &&
      currentAttendeeTimeSlot !== undefined
    ) {
      var dateSlot,
        timeSlot,
        totalSlots,
        waitingseats = "";
      var currentAttendeeSchdeule = JSON.parse(currentAttendee.schedules);
      if (currentAttendeeSchdeule !== undefined) {
        dateSlot = currentAttendeeSchdeule[0].date;
      }

      timeSlot = currentAttendeeTimeSlot.slotTime;
      totalSlots = currentAttendeeTimeSlot.seats;
      waitingseats = currentAttendeeTimeSlot.waitingseats;

      let numberOfAttendeesFound = 0;
      let numberOfConfrimAttendees = 0;
      let numberOfWatingAttendees = 0;
      if (
        attendeeSchedulesList !== undefined &&
        attendeeSchedulesList !== null &&
        attendeeSchedulesList.length > 0
      ) {
        attendeeSchedulesList.map((item, index) => {
          if (item.schedules) {
            let parsedSchedules = JSON.parse(item.schedules);
            if (parsedSchedules) {
              for (let p = 0; p < parsedSchedules.length; p++) {
                if (parsedSchedules[p].date === dateSlot) {
                  if (parsedSchedules[p].time) {
                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                      if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                        //numberOfAttendeesFound++;

                        if (
                          item.isConfirm === true ||
                          item.isWaiting === true
                        ) {
                          numberOfConfrimAttendees =
                            item.isConfirm == true
                              ? numberOfConfrimAttendees + 1
                              : numberOfConfrimAttendees;
                          numberOfWatingAttendees =
                            item.isWaiting == true
                              ? numberOfWatingAttendees + 1
                              : numberOfWatingAttendees;
                          numberOfAttendeesFound++;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }

      let numberOfAttendeeInfo = "";
      if (parseInt(totalSlots) > numberOfConfrimAttendees) {
        if (currentAttendee.isConfirm === true) {
          numberOfAttendeeInfo = (
            <div>
              {parseInt(totalSlots) - numberOfConfrimAttendees} slots remaining.
            </div>
          );
        } else {
          numberOfAttendeeInfo = (
            <div>
              {parseInt(totalSlots) - numberOfConfrimAttendees} slots remaining.
              To RSVP, enter your contact information below and confirm
              attendance.
            </div>
          );
        }
      } else {
        if (
          currentAttendee !== undefined &&
          currentAttendee.isConfirm === true
        ) {
          numberOfAttendeeInfo = (
            <div style={{ color: "red" }}>All slots filled</div>
          );
        } else {
          if (
            numberOfAttendeesFound >= parseInt(totalSlots) &&
            numberOfAttendeesFound <
              parseInt(totalSlots) + parseInt(waitingseats)
          ) {
            numberOfAttendeeInfo = (
              <div style={{ color: "red" }}>
                All slots filled, to be added to the waitlist please fill out
                your details.
              </div>
            );
          } else if (
            parseInt(totalSlots) + parseInt(waitingseats) ===
            numberOfAttendeesFound
          ) {
            numberOfAttendeeInfo = (
              <div style={{ color: "red" }}>
                No availability, all slots filled.
              </div>
            );
          }
        }
      }
      //let numberOfAttendeeInfo = (<div>{(parseInt(totalSlots) - numberOfAttendeesFound)} of {totalSlots} slots remaining.</div>);
      return <InfoMessage title={numberOfAttendeeInfo} />;
    }
  };

  const isSlotsFull = (dateSlot, timeSlot, totalSlots, waitingseats) => {
    let isFull = false;
    let numberOfAttendeesFound = 0;

    if (
      waitingseats === undefined ||
      waitingseats === null ||
      waitingseats === ""
    ) {
      waitingseats = "0";
    }

    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        //if (item.isConfirm === true) {
        //    numberOfAttendeesFound++;
        //}
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isConfirm === true || item.isWaiting === true) {
                        numberOfAttendeesFound++;
                      }
                      //numberOfAttendeesFound++;
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    if (numberOfAttendeesFound !== 0) {
      if (
        parseInt(totalSlots) + parseInt(waitingseats) ===
        numberOfAttendeesFound
      ) {
        isFull = true;
      }
    }
    return isFull;
  };

  const getConfirmedAndAvailableAttendeesData = (
    dateSlot,
    timeSlot,
    totalSeats
  ) => {
    let count = 0;
    var objConfirmAttendeeArray = [];
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isConfirm === true) {
                        objConfirmAttendeeArray.push(
                          <div
                            key={item.attendeeId}
                            className="confirmed-attendee"
                          >
                            <span>
                              {item.attendeeName} ({item.attendeeEmail})
                            </span>
                          </div>
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }

        //if (item.isConfirm === true) {
        //    objConfirmAttendeeArray.push(
        //        <div key={item.attendeeId} className="confirmed-attendee">
        //            <span>{item.attendeeName} ({item.attendeeEmail})</span>
        //        </div>
        //    )
        //}
      });
    }
    let availableSetsCount =
      parseInt(totalSeats) - objConfirmAttendeeArray.length;
    for (let i = 0; i < availableSetsCount; i++) {
      objConfirmAttendeeArray.push(
        <div key={i} className="available-attendee">
          <span>AVAILABLE</span>
        </div>
      );
    }
    return objConfirmAttendeeArray;
  };

  const getWaitingAttendeesData = (dateSlot, timeSlot, totalSeats) => {
    let count = 0;
    if (totalSeats === undefined || totalSeats === null || totalSeats === "") {
      totalSeats = "0";
    }
    var objWaitingAttendeeArray = [];
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isWaiting === true) {
                        objWaitingAttendeeArray.push(
                          <div
                            key={item.attendeeId}
                            className="confirmed-attendee"
                          >
                            <span>
                              {item.attendeeName} ({item.attendeeEmail})
                            </span>
                          </div>
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }

        //if (item.isWaiting === true) {
        //    objWaitingAttendeeArray.push(
        //        <div key={item.attendeeId} className="confirmed-attendee">
        //            <span>{item.attendeeName} ({item.attendeeEmail})</span>
        //        </div>
        //    )
        //}
      });
    }

    let availableSetsCount =
      parseInt(totalSeats) - objWaitingAttendeeArray.length;
    for (let i = 0; i < availableSetsCount; i++) {
      objWaitingAttendeeArray.push(
        <div key={i} className="available-attendee">
          <span>AVAILABLE</span>
        </div>
      );
    }

    return objWaitingAttendeeArray;
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  const getSlots = () => {
    if (!readOnly) {
      if (Array.isArray(customTimeSlots)) {
        customTimeSlots = getSortedTimeSlot(activeDay, customTimeSlots);
        return customTimeSlots;
      }

      const range = moment.range(
        `2018-01-01 ${dateRange[0]}`,
        `2018-01-01 ${dateRange[1]}`
      );
      return [...range.by("minutes", { step })].map((m) => {
        let isAvailableSeatsPopOverOpened = false,
          seats = 0,
          waitingseats = 0,
          duration = "60",
          durationunit = "minute",
          reminder = "yes",
          reminderhour = "24";
        if (selectedSlots.length > 0) {
          const selectedObj = selectedSlots.find(
            (x) => x.slotTime === m.format("HH:mm A")
          );
          if (selectedObj) {
            isAvailableSeatsPopOverOpened =
              selectedObj.isAvailableSeatsPopOverOpened;
            seats = selectedObj.seats;
            waitingseats = selectedObj.waitingseats;
            duration = selectedObj.duration;
            durationunit = selectedObj.durationunit;
            reminder = selectedObj.reminder;
            reminderhour = selectedObj.reminderhour;
          }
        }

        return {
          slotTime: m.format("HH:mm A"),
          isAvailableSeatsPopOverOpened: isAvailableSeatsPopOverOpened,
          seats: seats,
          waitingseats: waitingseats,
          duration: duration,
          durationunit: durationunit,
          reminder: reminder,
          reminderhour: reminderhour,
        };
      });
    } else {
      var hostSchedule = getSchedulesJSON(schedule);
      hostSchedule = hostSchedule.sort(function (a, b) {
        a = new Date(a);
        b = new Date(b);
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
      });

      return hostSchedule;
    }
  };

  const getSortedTimeSlot = (date, array) => {
    array = array.sort(function (a, b) {
      let a1 = moment(date + " " + a.slotTime, "MM/DD/YYYY HH:mm A")._d;
      let b1 = moment(date + " " + b.slotTime, "MM/DD/YYYY HH:mm A")._d;
      return a1 < b1 ? -1 : a1 > b1 ? 1 : 0;
    });
    return array;
  };

  const handleChange = useCallback(
    (slot) => () => {
      CheckWaitingList(activeDay, slot);
      setActiveDate(activeDay);
      if (!multiselect) {
        onChange({ slots: [slot], activeDay, isMulti: multiselect });
        return;
      }
      const isSlotFound =
        selectedSlots.find((x) => x.slotTime === slot.slotTime) !== undefined &&
        selectedSlots.find((x) => x.slotTime === slot.slotTime) !== null
          ? true
          : false;

      const slots = isSlotFound
        ? selectedSlots.filter((el) => el.slotTime !== slot.slotTime)
        : [...selectedSlots, { ...slot }];
      onChange({ slots, activeDay, isMulti: multiselect });

      setSelectedSlot(
        isSlotFound
          ? { ...selectedSlots.find((x) => x.slotTime === slot.slotTime) }
          : null
      );
    },
    [onChange, selectedSlots, activeDay, multiselect]
  );

  const getEmptyMessage = () => {
    if (!readOnly) {
      return (
        !activeDay && (
          <div>
            Select time slots below and then click on the{" "}
            <HelpIcon className="icon-style" />
            icon to set number of attendees and duration.
          </div>
          //<InfoMessage title='Select available date and then select time slot(s).' />
        )
      );
    } else {
      return readOnly;
    }
  };

  const getHourSlotHeader = () => {
    if (!readOnly) {
      return (
        <div className="hour-slot-header">
          <h4 className="page-subtitle">
            Time slots - {!activeDay ? "No Date Selected" : activeDay}
          </h4>
          {!readOnly && activeDay && !selectedSlots.length && (
            <InfoMessage title="Select time slot and confirm your attendance." />
          )}
        </div>
      );
    } else {
      return "";
    }
  };

  const getEndTime = (date, time) => {
    var datetime = "";
    var currentDate = moment(date + " " + time.slotTime, "MM/DD/YYYY HH:mm A");
    if (time.durationunit === "minute") {
      datetime = moment(currentDate._d).add(time.duration, "m").toDate();
      datetime = moment(datetime).format("hh:mm A");
    } else if (time.durationunit === "hour") {
      datetime = moment(currentDate._d).add(time.duration, "h").toDate();
      datetime = moment(datetime).format("hh:mm A");
    }
    return datetime;
  };

  const getStartTime = (time) => {
    var datetime = "";
    var datetime = moment(time, "HH:mm A");
    datetime = moment(datetime).format("hh:mm A");
    return datetime;
  };

  const getWaitlistSlots = (dateSlot, timeSlot, totalSlots) => {
    let numberOfWaitingAttendees = 0;
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isWaiting === true) {
                        numberOfWaitingAttendees += 1;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
    let numberOfAttendeeInfo = "";
    if (parseInt(totalSlots) === 0) {
      numberOfAttendeeInfo = <div style={{ color: "red" }}>None available</div>;
    } else if (parseInt(totalSlots) > numberOfWaitingAttendees) {
      numberOfAttendeeInfo = (
        <div>
          {parseInt(totalSlots) - numberOfWaitingAttendees} out of{" "}
          {parseInt(totalSlots)} remaining.
        </div>
      );
    }
    // else if (parseInt(totalSlots) === numberOfWaitingAttendees) {
    //     numberOfAttendeeInfo = (<div style={{ color: "red" }}>All slots filled.</div>);
    // }
    else {
      numberOfAttendeeInfo = (
        <div style={{ color: "red" }}>All slots filled.</div>
      );
    }

    return numberOfAttendeeInfo;
  };

  const getConfirmSlots = (dateSlot, timeSlot, totalSlots) => {
    let numberOfConfrimAttendees = 0;
    if (
      attendeeSchedulesList !== undefined &&
      attendeeSchedulesList !== null &&
      attendeeSchedulesList.length > 0
    ) {
      attendeeSchedulesList.map((item, index) => {
        if (item.schedules) {
          let parsedSchedules = JSON.parse(item.schedules);
          if (parsedSchedules) {
            for (let p = 0; p < parsedSchedules.length; p++) {
              if (parsedSchedules[p].date === dateSlot) {
                if (parsedSchedules[p].time) {
                  for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                      if (item.isConfirm === true) {
                        numberOfConfrimAttendees =
                          item.isConfirm == true
                            ? numberOfConfrimAttendees + 1
                            : numberOfConfrimAttendees;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
    let numberOfAttendeeInfo = "";
    if (parseInt(totalSlots) > numberOfConfrimAttendees) {
      numberOfAttendeeInfo = (
        <div>
          {parseInt(totalSlots) - numberOfConfrimAttendees} out{" "}
          {parseInt(totalSlots)} slots remaining.
        </div>
      );
    } else if (parseInt(totalSlots) === numberOfConfrimAttendees) {
      numberOfAttendeeInfo = (
        <div style={{ color: "red" }}>All slots filled.</div>
      );
    }

    return numberOfAttendeeInfo;
  };

  useEffect(() => {
    if (!isAttendeeData && selectedViewAttendeeData !== null) {
      getAttendeeViewData(selectedViewAttendeeData);
    }
  }, [isAttendeeData, selectedViewAttendeeData]);

  const getAttendeeViewData = (data) => {
    if (data && data !== undefined && data !== "") {
      var html = (
        <div className="attendee-confirmation">
          <div>
            <h4>Confirmed Attendees: </h4>
            {getConfirmSlots(
              data.selectedDate.date,
              data.time.slotTime,
              data.time.seats
            )}
          </div>

          <div className="attendees-data">
            {getConfirmedAndAvailableAttendeesData(
              data.selectedDate.date,
              data.time.slotTime,
              data.time.seats
            )}

            <div className="wait-list-attendee-info">
              <span>Waitlisted: </span>
              {getWaitlistSlots(
                data.selectedDate.date,
                data.time.slotTime,
                data.time.waitingseats
              )}
            </div>
            {getWaitingAttendeesData(
              data.selectedDate.date,
              data.time.slotTime,
              data.time.waitingseats
            )}
          </div>
        </div>
      );
      setAttendeeData(html);
      setIsOpenAtendeeViewModal(true);
    }
  };

  const openViewAttendeeModal = (
    isOpen,
    selectedDate,
    time,
    selectedDateTime
  ) => {
    dispatch(
      getAttendeeDataFlag({
        selectedDate: selectedDate,
        time: time,
        selectedDateTime: selectedDateTime,
      })
    );
    getSchedule(eventId)(dispatch);
    setSelectedDateTime(selectedDateTime);
  };

  const openSettingModal = (isOpen, selectedDate, time, selectedDateTime) => {
    if (isOpen) {
      setSelectedSlot(time);
      setSelectedDateTime(selectedDateTime);
    } else {
      setSelectedSlot(null);
    }
    setIsSettingViewModal(isOpen);
  };

  const openRescheduleModalModal = (
    isOpen,
    selectedDate,
    time,
    selectedDateTime
  ) => {
    var jsonData = [];
    var timeArray = [];
    timeArray.push(time);
    var rescheduledata = { date: selectedDate.date, time: timeArray };
    jsonData.push(rescheduledata);
    //var json = JSON.stringify(rescheduledata);

    if (isOpen) {
      setSelectedSlot(time);
      setSelectedDateTime(selectedDateTime);
    } else {
      setSelectedSlot(null);
    }
    setRescheduledata(jsonData);
    setIsRescheduleModal(isOpen);
  };
  const getReminderHours = () => {
    var remindersHours = [];
    for (var i = 0; i < 24; i++) {
      remindersHours.push(i + 1);
    }

    return remindersHours;
  };

  return (
    <div>
      {
        //<div className='hour-slot-header'>
        //    <h4 className='page-subtitle'>Time slots - {!activeDay ? 'No Date Selected' : activeDay}</h4>
        //    {!readOnly && activeDay && !selectedSlots.length && <InfoMessage title='Select time slot(s).' />}
        //</div>
      }

      {getHourSlotHeader()}
      <div className="slot-list">
        {!getEmptyMessage() ? (
          <>
            {getSlots().map((el, index) => {
              const isSlotFound =
                selectedSlots.find((x) => x.slotTime === el.slotTime) !==
                  undefined &&
                selectedSlots.find((x) => x.slotTime === el.slotTime) !== null
                  ? true
                  : false;
              const disabled = moment(new Date(), "MM/DD/YYYY HH:mm A").isAfter(
                moment(`${activeDay} ${el.slotTime}`, "MM/DD/YYYY HH:mm A"),
                "minute"
              );
              const className = classNames({
                "slot-list__item": true,
                "slot-list__item--active": isSlotFound,
                "slot-list__item--disabled":
                  disabled ||
                  (customTimeSlots &&
                    getRemainingSlotsCount(
                      activeDay,
                      el.slotTime,
                      el.seats,
                      el.waitingseats
                    )),
                "slot-list-full": isSlotsFull(
                  activeDay,
                  el.slotTime,
                  el.seats,
                  el.waitingseats
                ),
              });

              return (
                <div key={el.slotTime}>
                  <div className="info-inner">
                    <div
                      onClick={
                        disabled ||
                        (customTimeSlots &&
                          getRemainingSlotsCount(
                            activeDay,
                            el.slotTime,
                            el.seats,
                            el.waitingseats
                          ))
                          ? () => null
                          : handleChange(el)
                      }
                      className={className}
                    >
                      {el.slotTime}
                    </div>
                    {isSlotFound && (
                      <div className="info-btn">
                        {el.seats === "" ||
                        el.seats === 0 ||
                        el.seats === "0" ? (
                          <Tooltip title="Click to set max. number of attendees.">
                            <div>
                              <HelpIcon
                                onClick={(e) => {
                                  handlePopoverClick(e, el);
                                }}
                              />
                            </div>
                          </Tooltip>
                        ) : (
                          !customTimeSlots && (
                            <Badge
                              badgeContent={el.seats}
                              tooltip="abc"
                              onClick={(e) => {
                                if (!readOnly) {
                                  handlePopoverClick(e, el);
                                }
                              }}
                              color="error"
                            ></Badge>
                          )
                        )}

                        {el.isAvailableSeatsPopOverOpened && (
                          <Popover
                            id={id ? id + index : ""}
                            key={id ? id + index : index}
                            open={el.isAvailableSeatsPopOverOpened}
                            anchorEl={anchorEl}
                            onClose={handlePopoverClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <Typography
                              className={
                                classes.typography + " slot-popover-view"
                              }
                            >
                              <div>
                                <span>
                                  <b>{eventName}</b>
                                </span>
                              </div>
                              <div className="form-control-select-boxs">
                                <span># of attendees</span>
                                <TextField
                                  margin="normal"
                                  variant="outlined"
                                  id="confirmslot"
                                  inputRef={noofseets}
                                  fullWidth
                                  //label="Set # of available Slots"
                                  type="number"
                                  InputProps={{
                                    inputProps: { min: 1, max: 50 },
                                  }}
                                  //value={el.seats}
                                  defaultValue={el.seats}
                                  error={isAvailableSeatError}
                                  helperText={isAvailableSeatErrorMessage}
                                  onChange={(e) => {
                                    OnAvailableSeatsInputChange(e, el);
                                  }}
                                />
                              </div>

                              <div className="form-control-select-boxs">
                                <span># of waitlisted attendees</span>
                                <TextField
                                  margin="normal"
                                  variant="outlined"
                                  id="WaitingSlot"
                                  //inputRef={noofseets}
                                  fullWidth
                                  //label="Set # of wait-listed Slots"
                                  type="number"
                                  InputProps={{
                                    inputProps: { min: 0, max: 50 },
                                  }}
                                  //value={el.seats}
                                  error={isWaitingSeatError}
                                  helperText={isWaitingSeatErrorMessage}
                                  defaultValue={el.waitingseats}
                                  onChange={(e) => {
                                    OnAvailableWaitingSlotInputChange(e, el);
                                  }}
                                />
                              </div>
                              <div className="form-control-select-boxs Minutes-select-box">
                                <span>Event duration</span>
                                <TextField
                                  margin="normal"
                                  variant="outlined"
                                  id="duration"
                                  //inputRef={noofseets}
                                  fullWidth
                                  //label={'Set duration of Event (' + el.durationunit + 's)'}
                                  type="number"
                                  InputProps={{ inputProps: { min: 0 } }}
                                  error={isDurationSeatError}
                                  helperText={isDurationSeatErrorMessage}
                                  //value={el.seats}
                                  defaultValue={el.duration}
                                  onChange={(e) => {
                                    OnDurationInputChange(e, el);
                                  }}
                                />

                                <div className="Minutes-select">
                                  <FormControl variant="outlined">
                                    {
                                      //            <InputLabel id="DurationUnitLabel">
                                      //                Unit
                                      //</InputLabel>
                                    }
                                    <Select
                                      labelId="DurationUnitLabel"
                                      id="durationUnit"
                                      value={el.durationunit}
                                      onChange={(e) => {
                                        OnDurationUnitInputChange(e, el);
                                      }}
                                    >
                                      <MenuItem value={"hour"}>Hours</MenuItem>
                                      <MenuItem value={"minute"}>
                                        Minutes
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </div>

                              <div className="form-control-select-boxs Minutes-select-box1">
                                <span>Reminders </span>
                                <FormControl variant="outlined">
                                  <Select
                                    labelId="reminder"
                                    id="reminder"
                                    defaultValue={el.reminder}
                                    onChange={(e) => {
                                      OnReminderInputChange(e, el);
                                    }}
                                  >
                                    <MenuItem value={"yes"}>Yes</MenuItem>
                                    <MenuItem value={"no"}>No</MenuItem>
                                  </Select>

                                  <div className="Minutes-select">
                                    <Select
                                      labelId="reminderHours"
                                      id="reminderHours"
                                      defaultValue={el.reminderhour}
                                      onChange={(e) => {
                                        OnReminderHourInputChange(e, el);
                                      }}
                                    >
                                      {getReminderHours().map((el, index) => {
                                        return (
                                          <MenuItem value={el}>
                                            {el} Hours
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </div>
                                </FormControl>
                              </div>

                              <div
                                style={{
                                  float: "right",
                                  "margin-bottom": "10px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={(e) => {
                                    handlePopoverClose(e, el, true);
                                  }}
                                >
                                  Save
                                </Button>
                                <Button
                                  className="btn-close"
                                  variant="contained"
                                  onClick={(e) => {
                                    closeDialog(e, el);
                                  }}
                                  style={{ "margin-left": "5px" }}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Typography>
                          </Popover>
                        )}
                      </div>
                    )}
                    {customTimeSlots && (
                      <div>
                        {getRemainingSlots(
                          activeDay,
                          el.slotTime,
                          el.seats,
                          el.waitingseats
                        )}
                        {/*<InfoMessage title={"Total slots " + el.seats + "; " + 0 + " slots remaining"} />*/}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        ) : !readOnly ? (
          <div className="slot-list__empty">{getEmptyMessage()}</div>
        ) : (
          <div className="host-expand">
            {getSlots() &&
              getSlots().map((el, index) => {
                return (
                  <ExpansionPanel
                    key={"exp_" + index}
                    expanded={expanded === index}
                    onChange={handleExpandChange(index)}
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={classes.heading}>
                        {el.date}
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="expand-view">
                        {getSortedTimeSlot(el.date, el.time).map((item, i) => {
                          return (
                            <div
                              key={"_exp_inner_" + index + "_" + i}
                              className="sloat-info-main"
                            >
                              <div className="info-inner">
                                <div className="slot-list__item">
                                  {getStartTime(item.slotTime) +
                                    " - " +
                                    getEndTime(el.date, item)}
                                </div>
                              </div>
                              <div className="sloat-list-view">
                                <div>
                                  <span>
                                    Attendees:{" "}
                                    {getConfirmSlots(
                                      el.date,
                                      item.slotTime,
                                      item.seats
                                    )}{" "}
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    Waitlist:{" "}
                                    {getWaitlistSlots(
                                      el.date,
                                      item.slotTime,
                                      item.waitingseats
                                    )}{" "}
                                  </span>
                                </div>
                              </div>
                              <div className="action-view">
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    openSettingModal(
                                      true,
                                      el,
                                      item,
                                      getStartTime(item.slotTime) +
                                        " - " +
                                        getEndTime(el.date, item)
                                    )
                                  }
                                >
                                  SETTINGS
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    openViewAttendeeModal(
                                      true,
                                      el,
                                      item,
                                      getStartTime(item.slotTime) +
                                        " - " +
                                        getEndTime(el.date, item)
                                    )
                                  }
                                >
                                  VIEW ATTENDEES
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    openRescheduleModalModal(
                                      true,
                                      el,
                                      item,
                                      getStartTime(item.slotTime) +
                                        " - " +
                                        getEndTime(el.date, item)
                                    )
                                  }
                                >
                                  RESCHEDULE / CANCEL
                                </Button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                );
              })}
          </div>
        )}
      </div>
      {readOnly && (
        <ViewAttendeeModal
          isOpened={isOpenAtendeeViewModal}
          eventName={eventName}
          dateTime={selectedDateTime}
          AttendeeData={attendeeData}
          handleClose={() => setIsOpenAtendeeViewModal(false)}
        />
      )}

      {readOnly && selectedSlot && (
        <Setting
          isOpened={isSettingViewModal}
          eventName={eventName}
          dateTime={selectedDateTime}
          selectedSlot={selectedSlot}
          handleClose={() => setIsSettingViewModal(false)}
        />
      )}
      {readOnly && (
        <RescheduleModal
          isOpened={isRescheduleModal}
          eventName={eventName}
          dateTime={selectedDateTime}
          rescheduledata={rescheduledata}
          handleClose={() => setIsRescheduleModal(false)}
          eventId={eventId}
        />
      )}

      {!customTimeSlots && !readOnly && activeDay && selectedSlots.length > 0 && (
        <div className="info-tooltip-message help-icon">
          Please click on <HelpIcon className="icon-style" /> icon above to set
          number of attendees and event duration.
        </div>
      )}

      {
        //    readOnly && selectedSlot && !customTimeSlots && (<div className="attendee-confirmation">
        //    <div>
        //        <h4>Confirmed Attendees: </h4>{getConfirmRemainingSlots(activeDay, selectedSlot.slotTime, selectedSlot.seats)}
        //    </div>
        //    <div className="attendees-data">
        //        {getConfirmedAndAvailableAttendeesData(activeDay, selectedSlot.slotTime, selectedSlot.seats)}
        //        <div className="wait-list-attendee-info"><span>Wait-listed: </span>{getWaitingRemainingSlots(activeDay, selectedSlot.slotTime, selectedSlot.waitingseats)} </div>
        //        {getWaitingAttendeesData(activeDay, selectedSlot.slotTime, selectedSlot.waitingseats)}
        //    </div>
        //</div>)
      }

      {readOnly && customTimeSlots && (
        <div className="event-information">
          <div className="event-label">Event Description:</div>
          <div className="event-special-instructions">
            {specialInstructions}
          </div>
          {eventLocation && (
            <>
              <div className="event-label">Event Location:</div>
              <div className="event-special-instructions">
                <span>{eventLocation}</span>
              </div>
            </>
          )}
          <div className="event-duration">
            <span>
              <b>Duration:</b> {getDuration()}s
            </span>
          </div>
          <div className="event-status-info">
            {
              <div>{getRemainingAndWaitingSlotsCount()}</div>
              //getSlots().map((el, index) => {
              //    return (

              //    )
              //})
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default HourSlots;
